import { DocumentNode, gql } from '@apollo/client';
import {
  BoxProps,
  HStack,
  LinkBox,
  LinkOverlay,
  Spacer,
  Text,
  VStack,
} from '@chakra-ui/react';
import { convertFromRaw } from 'draft-js';
import NextLink from 'next/link';
import * as React from 'react';

import { AnswerButton } from '@/components/AnswerButton';
import { usePostHref } from '@/hooks/usePostHref';
import { BookOpenIcon } from '@/imports/ui/chakra/feather';

import { QuestionAnnouncement_QuestionFragment } from './graphql-types/QuestionAnnouncement_QuestionFragment';

import { Card } from '../Card';

const POST_FRAGMENT = gql`
  fragment QuestionAnnouncement_QuestionFragment on QuestionV2 {
    _id
    questionTitle: title
    questionBody: body
    ...AnswerButton_QuestionFragment
  }
  ${AnswerButton.questionFragment}
`;

export const Question: React.FC<
  {
    question: QuestionAnnouncement_QuestionFragment;
  } & BoxProps
> & { questionFragment: DocumentNode } = ({ question, children, ...rest }) => {
  const postHref = usePostHref(question._id);

  return (
    <LinkBox>
      <Card {...rest}>
        <VStack overflow="hidden" alignItems="start" spacing="0" h="100%">
          <HStack>
            <BookOpenIcon color="gray.500" />
            <Text textStyle="detail" color="gray.500" fontWeight="600">
              <LinkOverlay as={NextLink} href={postHref}>
                QUESTION
              </LinkOverlay>
            </Text>
          </HStack>
          <Text noOfLines={1} textStyle="bodyStrong">
            {question.questionTitle}
          </Text>
          <Text noOfLines={2} textStyle="detail">
            {convertFromRaw(question.questionBody).getPlainText()}
          </Text>
          <Spacer />
          <AnswerButton question={question} w="full" size="sm" />
        </VStack>
      </Card>
      {children}
    </LinkBox>
  );
};
Question.questionFragment = POST_FRAGMENT;
